//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VocHeaderMenuMobile from "./header-menu-mobile"
import mixins from "./mixins"
// import VocServicer from "@packages/servicer/src/main"
// eslint-disable-next-line no-unused-vars

    import Vue from "vue"

    
    let _i18n_vue = new Vue();
    const $t = _i18n_vue.$t.bind(_i18n_vue);
    

export default {
  name: "VocHeaderMenuNew",
  components: {
    VocHeaderMenuMobile
    // VocServicer
  },
  mixins: [mixins],
  methods: {
    menuClick(item) {
      this.$emit("menuClick", item)
    },
    menuOpen(route) {
      route.showIcon = true
      let blackList = this.pcPageBlack || []
      if (route.childrenAsync.length === 0) {
        route.childrenAsync = [
          ...route.children.filter(item => this.device === "mobile" || !blackList.includes(item.code))
        ]
      }
    },
    getRightWidth() {
      let initWidth = 232
      if (!this.params.unNeedSysPanel) {
        initWidth += 52
      }
      if (this.appName === "hotelcem" && !this.limitNewMenu) {
        initWidth += 130
      }
      return initWidth + "px"
    }
  }
  // ref: https://github.com/kopiro/siriwave#constructor-options
}
